import { render, staticRenderFns } from "./BaseNavigationPage.vue?vue&type=template&id=5ed57d0d&scoped=true&"
import script from "./BaseNavigationPage.vue?vue&type=script&lang=ts&"
export * from "./BaseNavigationPage.vue?vue&type=script&lang=ts&"
import style0 from "./BaseNavigationPage.vue?vue&type=style&index=0&id=5ed57d0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed57d0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VList,VListGroup,VListItem,VListItemAction,VListItemContent,VListItemTitle,VRow,VSheet})
